const SectionIds =
{
    sectionHome: 'home',
    sectionDemat: 'demat',
    section3EasySteps: 'easy-steps',
    sectionWhatYouGet: 'what-you-get',
    sectionStockMarketMantra: 'market-mantra',
    sectionInvestingOptions: 'options',
    sectionWGYC: 'services',
    sectionAboutMe: 'about-me',
    sectionTestimonials: 'testimonials',
    sectionContactMe: 'contact-me',
    sectionSipCalculator: 'sip-calculator',
    sectionQuote: 'quote',
    section404: '404'
}

export default SectionIds